var $50a61df6fac70d29$exports = {};
$50a61df6fac70d29$exports = {
    "clear": `Temizle`,
    "invalid": `(ge\xe7ersiz)`,
    "loading": `Y\xfckleniyor...`,
    "noResults": `Sonu\xe7 yok`,
    "valid": `(ge\xe7erli)`
};


export {$50a61df6fac70d29$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
